import {
    PostExternalProductReadUserBeforeOrderListForm,
    ProductExListElementType,
    ProductExListMapType,
    ProductExSearchParamType
} from "../interface";
import useGoToNavigation from "../../../../../util/useGotoNavigation";
import { UseFormRegister, UseFormWatch } from "react-hook-form";
import EmptyTableRow from "../../../../common/EmptyTableRow";
import { PaginationMain } from "../../../../../components/common/pagination/PaginationMain";
import AuthorityChecker from "../../../../../components/common/authorityGuard/AuthorityChecker";
import { useEffect, useState } from "react";

interface PropsType {
    product: ProductExListMapType,
    sideProduct: PostExternalProductReadUserBeforeOrderListForm,
    register: UseFormRegister<ProductExSearchParamType>,
    handleSubmit: any,
    watch: UseFormWatch<ProductExSearchParamType>
}

export default function List({ product, sideProduct, register, handleSubmit, watch }: PropsType) {
    const { goToNavigation } = useGoToNavigation();

    const clickRow = (el: ProductExListElementType) => {
        el.newErpProductid && goToNavigation(`product/detail/${el.newErpProductid}`, {}, false)
    }

    const handleOpenGuide = () => {
        window.open('/product_guide.html', '_blank', 'width=1200,height=800');
    };

    function BlobImage({ fileVO, alt }: { fileVO?: { fileKey: string; fileUrl: string; fileOrgname: string }, alt?: string }) {
        const [previewUrl, setPreviewUrl] = useState<string>();

        useEffect(() => {
            let objectUrl: string;

            async function loadImage() {
                if (!fileVO) return;
                try {
                    const res = await fetch(
                        `${process.env.REACT_APP_SERVER_URL}api/file/images_download?fileKey=${fileVO.fileKey}&fileUrl=${fileVO.fileUrl}&fileOrgname=${fileVO.fileOrgname}`
                    );
                    if (!res.ok) throw new Error("이미지 요청 실패");
                    const blob = await res.blob();
                    objectUrl = URL.createObjectURL(blob);
                    setPreviewUrl(objectUrl);
                } catch (e) {
                    console.error("이미지 로드 실패:", e);
                }
            }

            loadImage();

            return () => {
                if (objectUrl) URL.revokeObjectURL(objectUrl);
            };
        }, [fileVO]);

        if (!fileVO) return <span>이미지 없음</span>;
        if (!previewUrl) return <span>이미지 로딩 중...</span>;

        return (
            <img
                src={previewUrl}
                alt={alt ?? fileVO.fileOrgname}
                style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain",
                }}
            />
        );
    }


    return <div className="content_wrap">
        <div className="row mb-15px">
            <div className="col-6">
                <div className="frm_row">
                    <h6 className="table_stats">결과 내 검색(<span>{product.totalCount ?? 0}</span>건)</h6>
                    {/*<label htmlFor="" className="form-label frm_label">결과 내 검색</label>*/}
                </div>
            </div>
            <div className="col-6">
                <form onSubmit={handleSubmit} className="frm_row search">
                    <select className="form-select w-150px"
                        value={watch("keywordType2")}
                        {...register("keywordType2")}>
                        <option value={"1"}>전체</option>
                        <option value={"2"}>벤더</option>
                        <option value={"3"}>카테고리</option>
                        <option value={"4"}>품목</option>
                        <option value={"5"}>규격</option>
                        <option value={"6"}>중분류</option>
                        <option value={"7"}>대분류</option>
                    </select>
                    <input type="text"
                        className="form-control w-250px ms-5px"
                        value={watch("keyword2")}
                        {...register("keyword2")} />
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <button className="btn btn-info btn_search ms-5px">
                            <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt="" />조회
                        </button>
                    </div>
                    {/* NOTE: 구매 가이드 버튼 없음 */}
                    <button className="btn btn-primary w-100px" onClick={handleOpenGuide}>구매 가이드</button>
                </form>
            </div>
        </div>

        <div className="products_container">
            <div className="left">
                <table className="table table-bordered my_table">
                    <thead>
                        <tr>
                            <th style={{ width: "21.8%" }}>이미지</th>
                            <th style={{ width: "68.6%" }}>상품 상세</th>
                            <AuthorityChecker authorityNames={['orderWriteYn']}>
                                <th></th>
                            </AuthorityChecker>
                        </tr>
                    </thead>
                    <tbody>
                        {product.productList.length !== 0 ?
                            product.productList.map(el =>
                                <tr className="h-166px clickable" onClick={() => clickRow(el)}>
                                    <td className="p-4px">
                                        <div
                                            style={{
                                                width: "288px",
                                                height: "166px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                backgroundColor: "#fff",
                                            }}
                                        >
                                            {el.erpProductImageVO ? (
                                                <img
                                                    src={
                                                        process.env.REACT_APP_SERVER_URL +
                                                        `api/file/images_download?fileKey=${el.erpProductImageVO.fileKey}&fileUrl=${el.erpProductImageVO.fileUrl}&fileOrgname=${el.erpProductImageVO.fileOrgname}`
                                                    }
                                                    alt={el.erpProductImageVO.fileOrgname ?? ""}
                                                    style={{
                                                        maxWidth: "100%",
                                                        maxHeight: "100%",
                                                        objectFit: "contain",
                                                    }}
                                                />
                                            ) : (
                                                <span style={{ color: "#999", fontSize: "14px" }}>이미지 없음</span>
                                            )}
                                        </div>
                                    </td>
                                    <td>
                                        {/* TODO: vendor-category로 추정되는데 일단 이대로 냅둠 > 미정 상태 */}
                                        <div className="line0">
                                            {el.majorCategory !== "" && `[${el.majorCategory}]`} {el.subCategory}
                                        </div>
                                        <div className="line1">{el.new_txt_nm_item}</div>
                                        <div className="line2">{el.new_txt_stnd_item}</div>
                                        <div className="line3_lg">{el.productExplain}</div>
                                    </td>
                                    <AuthorityChecker authorityNames={['orderWriteYn']}>
                                        <td>
                                            <div className="d-flex flex-column justify-content-center align-items-center">
                                                {/* NOTE: 장바구니 없음 */}
                                                {/*<button className="btn btn-outline-dark w-110px mx-0 mb-5px px-0">*/}
                                                {/*    <img className="me-5px"*/}
                                                {/*         src={process.env.PUBLIC_URL + "/assets/images/icon_shopping_cart.png"}*/}
                                                {/*         alt=""/>장바구니*/}
                                                {/*</button>*/}
                                                <button className="btn btn-dark mx-0 w-110px">구매하기</button>
                                            </div>
                                        </td>
                                    </AuthorityChecker>
                                </tr>)
                            : <EmptyTableRow colSpan={3} />
                        }
                    </tbody>
                </table>
            </div>

            {/* TODO: 1. 사이드 배너(Sticky)인지? // 2. 구매내역 API 있는지? */}
            <div className="right">
                <div className="recent_top">구매내역</div>
                <div className="recent_content">
                    <ul className="recent_list" style={{ marginBottom: '10px' }}>
                        {/* Render sideProduct items if it's an array, otherwise display a message */}
                        {sideProduct?.list?.length > 0 ? (
                            sideProduct.list.map((item, idx) => (
                                <li key={idx} onClick={() => goToNavigation(`product/detail/${item?.newLErpProductValue}`, {}, false)}>
                                    <a>
                                        <div
                                            style={{
                                                width: "180px",
                                                height: "200px",
                                                backgroundColor: "#fff",
                                                border: "1px solid #ddd",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            }}
                                        >
                                            {item?.erpProductImageVO ? (
                                                <img
                                                    src={`${process.env.REACT_APP_SERVER_URL}api/file/images_download?fileKey=${item.erpProductImageVO.fileKey}&fileUrl=${item.erpProductImageVO.fileUrl}&fileOrgname=${item.erpProductImageVO.fileOrgname}`}
                                                    alt=""
                                                    style={{
                                                        maxWidth: "100%",
                                                        maxHeight: "100%",
                                                        objectFit: "contain",
                                                    }}
                                                />
                                            ) : (
                                                <span
                                                    style={{
                                                        color: "#999",
                                                        fontSize: "14px",
                                                    }}
                                                >
                                                    이미지 없음
                                                </span>
                                            )}
                                        </div>
                                    </a>
                                </li>
                            ))
                        ) : (
                            <li className="text-center">구매내역이 없습니다.</li>
                        )}


                        {/* <li>
                            <a href="#/link-1">
                                <img src={process.env.PUBLIC_URL + "/assets/images/ex_image_sm.png"} alt=""/>
                            </a>
                        </li>
                        <li>
                            <a href="#/link-1">
                                <img src={process.env.PUBLIC_URL + "/assets/images/ex_image_sm.png"} alt=""/>
                            </a>
                        </li>
                        <li>
                            <a href="#/link-1">
                                <img src={process.env.PUBLIC_URL + "/assets/images/ex_image_sm.png"} alt=""/>
                            </a>
                        </li>
                        <li>
                            <a href="#/link-1">
                                <img src={process.env.PUBLIC_URL + "/assets/images/ex_image_sm.png"} alt=""/>
                            </a>
                        </li> */}
                    </ul>
                </div>
            </div>
        </div>

        <PaginationMain totalCount={product.totalCount ?? 0} />
    </div>
}